import i18next from "i18next";

export const netGrossOptions = [
    { label: i18next.t("netto"), value: "net" },
    { label: i18next.t("brutto"), value: "gross" },
];

export const candidatesRankingsOptions = [
    { label: i18next.t("Kandydaci powyżej") + " ★★★★★", value: 5 },
    { label: i18next.t("Kandydaci powyżej") + " ★★★★☆", value: 4 },
    { label: i18next.t("Kandydaci powyżej") + " ★★★☆☆", value: 3 },
    { label: i18next.t("Kandydaci powyżej") + " ★★☆☆☆", value: 2 },
    { label: i18next.t("Kandydaci powyżej") + " ★☆☆☆☆", value: 1 },
    { label: i18next.t("Kandydaci powyżej") + " ☆☆☆☆☆", value: 0 }
];